export const CGP_CLIENT_KEY = "cgp_client";

export const HIDE_MENU_KEY = "?hideInsideMenu=true";